import { TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import React from "react";
import { Editor } from "react-draft-wysiwyg";
import { languages } from "../../constants/languages";
import AttachmentsContainer from "../../containers/settings/AttachmentsContainer";
export default class InfoSettings extends React.Component {
  state = {
    descriptionHover: false,
  };
  render() {
    return (
      <div style={{ width: "100%", paddingTop: 35, paddingBottom: 50 }}>
        <div style={{ width: 650, maxWidth: "97%", margin: "auto" }}>
          <Button
            onClick={(e) => {
              this.props.handleBack();
            }}
            variant="text"
            size="small"
            style={{ marginBottom: 15 }}
          >
            <ArrowBackIcon style={{ height: 18 }} />
            <span>{languages.general.back}</span>
          </Button>
          <Typography variant="h6">
            {languages.tournament.showTournamentInfo}
          </Typography>
          <Typography variant="subtitle2" style={{ marginTop: 5 }}>
            {languages.tournament.description}
          </Typography>
          <Typography
              variant="caption"
              style={{ display: "block", marginBottom: 5 }}
            >
              {languages.tournament.descriptionSubtitle}
            </Typography>
          <div style={{ display: "flex" }}>
            {(this.props.tournament.lang || []).length > 1 && (
              <div
                style={{
                  borderRight: "1px solid lightgray",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Button
                  onClick={(e) => {
                    this.props.handleDescriptionTrChange(null);
                  }}
                  variant="text"
                  size="small"
                  style={{ fontWeight: this.props.tr === null ? 500 : 300 }}
                >
                  {(this.props.tournament.lang || [])[0]}
                </Button>
                {(this.props.tournament.lang || []).slice(1).map((lang) => {
                  return (
                    <Button
                      key={lang}
                      onClick={(e) => {
                        this.props.handleDescriptionTrChange(lang);
                      }}
                      variant="text"
                      size="small"
                      style={{ fontWeight: this.props.tr === lang ? 500 : 300 }}
                    >
                      {lang}
                    </Button>
                  );
                })}
              </div>
            )}
            <div
              style={{
                width: "100%",
                paddingLeft:
                  (this.props.tournament.lang || []).length > 1 ? 20 : 0,
              }}
            >
              <div
                style={{ cursor: "text" }}
                onClick={this.props.toggleDescriptionDialog}
                onMouseEnter={() => {
                  this.setState({ descriptionHover: true });
                }}
                onMouseLeave={() => {
                  this.setState({ descriptionHover: false });
                }}
              >
                <Editor
                  readOnly
                  editorState={this.props.currentTournamentDescriptionState}
                  editorStyle={{
                    border: this.state.descriptionHover
                      ? "1px solid #000000"
                      : "1px solid #F1F1F1",
                    borderRadius: 2,
                    minHeight: 150,
                    maxHeight: 150,
                  }}
                  toolbarHidden
                />
              </div>
            </div>
          </div>
          {/* <div>
            <Typography variant="subtitle2" style={{ marginTop: 20 }}>
              {languages.tournament.pinnedMessage}
            </Typography>
            <Typography
              variant="caption"
              style={{ display: "block", marginBottom: 5 }}
            >
              {languages.tournament.pinnedMessageDescription}
            </Typography>
            {this.props.pinnedMessageTitle ? (
              <div style={{ paddingBottom: 3 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    border: "1px solid lightgray",
                    padding: 5,
                    alignItems: "center",
                    borderRadius: 5,
                    background: "white",
                  }}
                >
                  <Typography>{this.props.pinnedMessageTitle}</Typography>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <IconButton
                      aria-label="Change"
                      onClick={this.props.handleDeletePinnedMessage}
                      style={{ height: 30, width: 30 }}
                    >
                      <DeleteIcon
                        style={{
                          height: 20,
                          width: 20,
                          position: "absolute",
                          top: 5,
                        }}
                      />
                    </IconButton>
                  </div>
                </div>
              </div>
            ) : (
              <Button
                fullWidth
                variant="outlined"
                component="span"
                onClick={this.props.togglePinnedMessageDialog}
              >
                <MessageIcon
                  style={{ height: 16, width: 16, marginRight: 5 }}
                />
                {languages.tournament.pinnedMessageNew}
              </Button>
            )}
          </div> */}
          <AttachmentsContainer
            tournament={this.props.tournament}
            user={this.props.user}
            userData={this.props.userData}
            userStatus={this.props.userStatus}
            tournamentStatus={this.props.tournamentStatus}
          />
          {this.props.tournament.online && (
            <div>
              <Typography
                variant="subtitle2"
                style={{ marginBottom: 5, marginTop: 20 }}
              >
                {languages.tournament.chatURL}
              </Typography>
              <TextField
                style={{ paddingBottom: 15 }}
                placeholder={languages.tournament.chatURLPlaceholder}
                onClick={this.props.toggleChatURLDialog}
                fullWidth
                // label={languages.tournament.chatURL}
                name="chatURL"
                value={this.props.tournament.chatURL || ""}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
          )}
          <div>
            <Typography variant="subtitle2" style={{ marginTop: 20 }}>
              {languages.tournament.sponsors}
            </Typography>
            <Typography
              variant="caption"
              style={{ display: "block", marginBottom: 5 }}
            >
              {languages.tournament.sponsorsDescriptionInfo}
            </Typography>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.props.combineSponsors}
                  onChange={this.props.handleCombineSponsorsChange}
                  color="primary"
                  name="combineSponsors"
                />
              }
              label={<div>{languages.tournament.combineSponsorBlocks}</div>}
            />
          </div>
        </div>
      </div>
    );
  }
}
